<template>
    <div class="xi">
        <hd-com></hd-com>
        <searchhdCom></searchhdCom>
           <div class="content-wrap">
            <div class="center-box">
                <div class="content clearfix" style="position: relative;">
                     <div class="center-center flex-start flex-wrap">
                        <div class="shopGoodBox">
                            <div class="shopGoodBoxPay">
                                <div v-if="orderNum == 0"><i class="el-icon-success" style="font-size:62px;color:#00AFB5"></i></div>
                                <div v-if="orderNum == 1"><i class="el-icon-error" style="font-size:62px;color:#00AFB5"></i></div>
                                <div v-if="orderNum == 0" style="font-size: 24px;color: #00AFB5;margin-top:10px">购买成功我们尽快为您处理</div>
                                <div v-if="orderNum == 1" style="font-size: 24px;color: #00AFB5;margin-top:10px">购买失败我们尽快为您处理</div>
                                <div style="margin-top:10px" @click="gonewClick">
                                    <el-button type="primary">继续逛逛</el-button>
                                </div>
                            </div>
                        </div>
   
                     </div>
                </div>
            </div>
           </div>
        <ft-com></ft-com>
        <rt-bar></rt-bar>
    </div>
</template>

<script>


import hdCom from '../../components/intshopheader'
import searchhdCom from '../../components/insearchHeader'
import ftCom from '../../components/footer'
// import rtBar from "../../components/right";
export default {
    name: "healthKnow",
    components: {
        hdCom,
        searchhdCom,
        ftCom,
        // rtBar
    },
    data() {
        return {
            DetailData:{},
            payType:0,
            assetsBalanceIsTrue:false,
            orderNum:this.$route.query.order,
        }
    },
    methods: {
        gonewClick(){
            var _this = this
            _this.$router.push({
                path: './shopPage'
            })
        }
    },
    mounted() {
        // this.Detail();
    },
    destroyed() {
        //销毁监听
    },
}
</script>
<style lang="scss" scoped>
.flex-l-s {
    display: flex;
    justify-content: space-between;
}
.shopTab {
    border-bottom: 1px solid #E6E6E6;
}
.shopTabBox {
    display: flex;
    align-items: center;
}
.shopTabno {
    font-size: 15px;
    // color: #FFFFFF;
    font-weight: bold;
    padding: 10px 50px;
    cursor: pointer;
}
.shopTabChecked {
    font-size: 15px;
    padding: 10px 50px;
     cursor: pointer;
}
.tagcomCheck {
    padding: 5px 15px;
    border-radius: 2px;
    border: 1px solid #00AFB5;
    font-size: 14px;
    color: #00AFB5;
    margin-left: 10px;
    cursor: pointer;
}
.tagcom {
    padding: 5px 15px;
    background: #F0F0F0;
    border-radius: 2px;
    font-size: 14px;
    margin-left: 10px;
    color: #333333;
    cursor: pointer;
}

.banner {
    height: 116px;
    background: url("../../assets/img/jbk_banner.png")center no-repeat;
}
.shopGoodBox {
    width: 100%;
    background: #FFFFFF;
    border-radius: 2px;
     min-height: 400px;
    padding: 30px;
}
.flex-l {
    display: flex;
    align-items: center;
}
.shopGoodBoxTop {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
}
.shopGoodBoxPayTitle {
    background: #F5F5F5;
    padding: 13px 20px;
    color: #999999;
}
.shopGoodBoxPayType {
    padding: 30px 20px;
     min-height: 400px;
}
.shopGoodBoxPay {
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #FFFFFF;
    margin-top: 15px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.shopGoodBoxOrd {
    font-size: 14px;
    color: #999999;
}
.shopGoodBoxRight {
    margin-left: 60px;
}
.shopGoodBoxName {
    font-weight: bold;
    font-size: 20px;
    color: #1A1A1A;
}
.shopGoodPrice {
    font-size: 24px;
    color: #E1251B;
    margin-bottom: 30px;
}
.shopGoodBot {
    margin-top: 30px;
}
.shopGoodBoxSold {
    font-size: 16px;
    color: #CCCCCC;
}
.banner-text {
    width: 1200px;
    margin: 0 auto;

    h3 {
        padding-top: 25px;
        font-size: 26px;
        font-weight: normal;
        color: #ffffff;
    }

    p {
        font-size: 18px;
        color: #ffffff;

        a {
            color: #ffffff;
            font-size: 14px;
            margin: 0 5px;
        }
    }
}

.content-wrap {
    background: #F5F6F6;
}


.content {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0;

}

.menu-box {
    width: 100%;
    background: #fff;
    height: auto;

    .box {
        align-items: flex-start !important;
        margin-bottom: 10px;
    }

    .menu-title {
        width: 90px;
        font-size: 16px;
        height: 40px;
        line-height: 40px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .menu-content {
        width: calc(100% - 95px);
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .menu-item {
        width: auto;
        margin: 0 5px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        height: 40px;
        padding: 0 10px;
    }

    .menu-item:hover {
        background: #F5F6F6;
        border-radius: 2px;
        color: #00998B;
        cursor: pointer;
    }

    .menuActive {
        background: #F5F6F6;
        border-radius: 2px;
        color: #00998B;
    }
}



.healthKnow .el-radio {
    margin-right: 30px;
}

#page ::v-deep .el-pagination {
    text-align: center;
    margin: 30px auto;
}

#page ::v-deep .el-pagination.is-background .btn-next,
#page ::v-deep .el-pagination.is-background .btn-prev,
#page ::v-deep .el-pagination.is-background .el-pager li {
    background-color: #fff;
}

#page ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #01C2AC;
}

#page ::v-deep .el-pagination.is-background .btn-next,
#page ::v-deep .el-pagination.is-background .btn-prev,
#page ::v-deep .el-pagination.is-background .el-pager li {
    border-radius: 2px;
}
</style>
